import Nullstack from 'nullstack';
export default function IconListCheck({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-list-check",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M3.5 5.5l1.5 1.5l2.5 -2.5"
  }), "   ", Nullstack.element("path", {
    d: "M3.5 11.5l1.5 1.5l2.5 -2.5"
  }), "   ", Nullstack.element("path", {
    d: "M3.5 17.5l1.5 1.5l2.5 -2.5"
  }), "   ", Nullstack.element("line", {
    x1: "11",
    y1: "6",
    x2: "20",
    y2: "6"
  }), "   ", Nullstack.element("line", {
    x1: "11",
    y1: "12",
    x2: "20",
    y2: "12"
  }), "   ", Nullstack.element("line", {
    x1: "11",
    y1: "18",
    x2: "20",
    y2: "18"
  }), " ");
}